import noScroll from "no-scroll";

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export const noBodyScroll = (isOpen) => {
    const { width } = getWindowDimensions();

    if (isOpen && width < 768) {
        noScroll.on();
    }
    else {
        noScroll.off();
    }
}